import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { useLocation } from '@hooks/useLocation';
import { EXTRA_ACTIONS } from '../constants/headerLinkTypes';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';

/**
 * Displays Links with target and rel for external links.
 *
 * @param props - details from component and environment API props
 * @returns {*} HTML content.
 */
const CheckLinkType = props => {

    const {
        details: {
            name,
            linkClassName,
            additionalProperties,
            text,
            path,
            additionalPath,
            beforeClick,
            extraAction,
            externalLink
        },
        environment: {
            links
        },
        index,
        replacements,
        ssapForm,
        showModal
    } = props;

    const appendAdditionalPath = (mainPath) => {
        if (typeof additionalPath === 'string') {
            return mainPath + additionalPath;
        } else {
            return mainPath;
        }
    };

    let url = path && links[path] && appendAdditionalPath(links[path]) ? appendAdditionalPath(links[path]).processReplacements(replacements): '';
    if (externalLink && externalLink.length > 0) {
        url = externalLink;
    }

    
    const intl = useIntl();
    const onBeforeClick = () => {
        beforeClick();
        window.location.href = url;
    };

    const { isSsap } = useLocation();

    const getCTA = () => {
        const defaultLinkProps = { href: url };
        switch(extraAction) {
            case EXTRA_ACTIONS.CHECK_SSAP:
                switch(true) {
                    case isSsap && !ssapForm:
                        return {
                            onClick: () => {
                                showModal({
                                    modalType: MODAL_TYPES.LEAVE_PAGE_MODAL,
                                    modalData: {
                                        url
                                    }
                                });
                            }
                        };
                    default:
                        return defaultLinkProps;
                }
            default:
                return defaultLinkProps;
        }
    };

    return additionalProperties ?

        React.createElement(
            'a',
            {
                href: url,
                className: linkClassName,
                id: name + '_' +index,
                'data-automation-id': name,
                target: additionalProperties.target,
                rel: additionalProperties.rel,
                title: intl.formatMessage({ id:'header.logo.link.title' })
            },
            <FormattedMessage
                id = {text}
                values = {replacements}
            />

        )
        :
        (
            <Fragment>
                {
                    beforeClick &&
                    React.createElement(
                        'a',
                        {
                            href: '#',
                            onClick: onBeforeClick,
                            className: linkClassName,
                            id: name + '_' +index,
                            'data-automation-id': name
                        },
                        <FormattedMessage
                            id = {text}
                            values = {replacements}
                        />
                    )
                }
                {
                    !beforeClick &&
                    React.createElement(
                        'a',
                        {
                            ...getCTA(),
                            className: linkClassName,
                            id: name + '_' +index,
                            'data-automation-id': name
                        },
                        <FormattedMessage
                            id = {text}
                            values = {replacements}
                        />
                    )
                }
            </Fragment>
        );

};

export default CheckLinkType;